import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Catchy Mager';
    src: url('/fonts/Catchy Mager Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  @font-face {
    font-family: 'CursiveNice';
    src: url('/fonts/cursive_nice_n_new-webfont.woff2') format('woff2'),
         url('/fonts/cursive_nice_n_new-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body, #root {
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
    margin: 0;
    padding: 0;
    position: relative;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    background-color: #fff;
    color: #333;
  }

  #root {
    display: block;
    position: relative;
  }

  .script-font {
    font-family: 'CursiveNice', sans-serif !important;
  }


`;

export default GlobalStyles;
